import Address from './components/Address'
import StorageService from './services/StorageService'
import Store from './services/Store'
import { isValid } from './utils/fields'

const initSkubacz = () => {
  if ($(".homepage").length > 0) {
    const $addressForm = $('#search_form')
    const address =  Object.assign({}, StorageService.getJSONItem('deliveryAddress'), { country: 'PL' } )

    const store = Store.create(
      Address.init({address: address, afterSubmit: false }),
      Address.update
    )

    store.subscribe( () => {
      const st = store.getState()
      Address.view($addressForm, st, store.dispatch )
    })

    store.dispatch({ type: 'INIT' })

    $addressForm.submit( () => {
      const state = store.getState()
      return isValid(state.fields) && state.errors.length === 0
    })
  }
}

$(document).ready(initSkubacz)
